import type { AdminTableRow } from "../pages/adminContent";

interface AdminTableProps {
  readonly title: string;
  readonly rows: readonly AdminTableRow[];
}

export function AdminTable({ title, rows }: AdminTableProps) {
  return (
    <section className="admin-panel admin-table-panel">
      <h2>{title}</h2>
      <table className="admin-table">
        <thead>
          <tr>
            <th scope="col">Item</th>
            <th scope="col">Detail</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.label}-${row.status}`}>
              <td>{row.label}</td>
              <td>{row.detail}</td>
              <td>{row.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
